export default __webpack_public_path__ + "static/media/he.9ae0ae18.jpg";